export default  {
    validation : {
        level : false,
        idKotaKab : false
    },
    optionStatusTc: [
        {
            name: "TC",
            status: "1",
        },
        {
            name: "Workshop",
            status: "0",
        },
    ],
    showBiayaPerMataUji: false,
    currentPage: 0,
    instruktur: [],
    mataUji: [],
    levelPeruntukan: [],
    kotaKab: [],
    option_grader: [],
    modelLevelPeruntukan: [],
    formData: {
    instrukturSertifikasiRplRequest: [
        {
            idInstrukturRpl: "",
            instruktur: "",
            keterangan: "",
            nilai: "",
            invalid_instruktur : false,
        },
    ],
    dokumenPendukungSertifikasiRplRequest: [
        {
            kode_dokumen: "",
            nama_dokumen: "",
            contoh_dokumen: "",
            statusUpdateFile: "",
            idMasterDokumenPendukung : "",
            fileName: "",
            invalid_dokumen : false,
        },
    ],
    dokumenPersyaratanSertifikat: [
          {
            idDokumenPendukung : "",
            idMasterDokumen: "",
            invalid_dokumen : false,
            modelMultiSelect: [],
          },
    ],
    sertifikasiRplMataUjiRequest: [
        {
            idMasterMataUji: "",
            deskripsi: "",
            batasNilai: "",
            nilaiMinimum: "",
            graderSatu: "",
            graderDua: "",
            status_tc: "",
            modelStatusTc: "",
            invalid_mata_uji : false,
        },
    ],
    kodeRpl: "",
    namaRpl: "",
    idLevel: "",
    biaya: 0,
    biayaMengulang: 0,
    tanggalDimulai: "",
    tanggalBerakhir: "",
    lokasi: "",
    idKotaKab: "",
    kategori: "",
    kategoriCpai: "",
    kapasitas: "",
    status: "",
    biayaPerMataUji: 0,
    skpTerstruktur: "",
    skpNonTerstruktur: "",
    skpAssessment: "",
    baseUrl: "",

    idKategoriRpl: "7ac2c3e2-6932-4208-9391-d1088b73a42e",
    },
}